<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'MAG'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["WLRPT"]["MAG"]}}
                                                <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AGT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["AGT"]}}
                                                <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["CI"] }}
                                                <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ACTM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["ACTM"] }}
                                                <i @click="setSortTable('AM')" :class="setSortLogo('AM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TBA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(1))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["BETRPT"]["BNS"] }}
                                                <i @click="setSortTable('TBA')" :class="setSortLogo('TBA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TDLS' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(2))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["REWARD"] }}
                                                <i @click="setSortTable('TDLS')" :class="setSortLogo('TDLS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TABA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(3))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["BETRPT"]["ARB"] }}
                                                <i @click="setSortTable('TABA')" :class="setSortLogo('TABA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TAA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(4))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["BETRPT"]["AFF"] }}
                                                <i @click="setSortTable('TAA')" :class="setSortLogo('TAA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TTA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['EBD']['TNMTA']}}
                                                <i @click="setSortTable('TTA')" :class="setSortLogo('TTA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TPA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['EBD']['PDA']}}
                                                <i @click="setSortTable('TPA')" :class="setSortLogo('TPA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TFSA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(7))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['FS']}}
                                                <i @click="setSortTable('TFSA')" :class="setSortLogo('TFSA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GTA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['TE']}}
                                                <i @click="setSortTable('GTA')" :class="setSortLogo('GTA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GTHA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['TEA']}}
                                                <i @click="setSortTable('GTHA')" :class="setSortLogo('GTHA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TTAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['EBD']['TNMTH']}}
                                                <i @click="setSortTable('TTAH')" :class="setSortLogo('TTAH')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TPAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['EBD']['PDH']}}
                                                <i @click="setSortTable('TPAH')" :class="setSortLogo('TPAH')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('EBD', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['EBD']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :options="dd_agentgroup"
                                                  v-model="arr_FV['AGI']"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SAGT']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :options="dd_subagentgroup"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            :disabled="disableSubDD"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['PTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['PTS'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['PTS'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['PTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['PTS'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['PTS'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["EBD"]["ET"]}} :</span>
                                <treeselect :multiple="true"
                                            :limit="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :limitText="count => `+${count}`"
                                            :options="dd_expense_type"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MSA.ET')"
                                            v-model="arr_FV['ET']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currencyfilter"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CCI']"
                                            @input="updateCC()" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['EBD']['EBDL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="26" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                            <tr v-if=" arr_ExpenseBreakGroupByList.length == 0"><td colspan="100%">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in arr_ExpenseBreakGroupByList" class="reportTotal">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        <a href="#" @click="ShowDetails(data.ISOC)">{{getLanguage['WLRPT']['VA']}}</a>
                                    </template>
                                    <template v-else-if="header == 'MAG'">
                                    </template>
                                    <template v-else-if="header == 'AGT'">
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        {{ renderCurrency(data.ISOC) }}
                                    </template>
                                    <template v-else-if="header == 'ACTM'">
                                        {{ data.AM }}
                                    </template>
                                    <template v-else-if="header == 'TBA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(1))" class="tableCtnRight">
                                        {{ formatNumber(data.TBOC * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TDLS' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(2))" class="tableCtnRight">
                                        {{ formatNumber(data.TDLSA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TABA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(3))" class="tableCtnRight">
                                        {{ formatNumber(data.TABA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TAA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(4))" class="tableCtnRight">
                                        {{ formatNumber(data.TAA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TTA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))" class="tableCtnRight">
                                        {{ formatNumber(data.TTA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TTAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))" class="tableCtnRight">
                                        {{ formatNumber(data.TTAH * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TPA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))" class="tableCtnRight">
                                        {{ formatNumber(data.TPA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TPAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))" class="tableCtnRight">
                                        {{ formatNumber(data.TPAH * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'TFSA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(7))" class="tableCtnRight">
                                        {{ formatNumber(data.TFSA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'GTA'" class="tableCtnRight">
                                        {{ formatNumber(data.TEA * -1, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'GTHA'" class="tableCtnRight">
                                        {{ formatNumber(data.THEA * -1, 2, data.ISOC, false) }}
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="renderStyle(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'MAG'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["WLRPT"]["MAG"]}}
                                        <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["AGT"]}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACTM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["ACTM"] }}
                                        <i @click="setSortTable('AM')" :class="setSortLogo('AM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TBA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(1))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["BETRPT"]["BNS"] }}
                                        <i @click="setSortTable('TBA')" :class="setSortLogo('TBA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TDLS' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(2))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["REWARD"] }}
                                        <i @click="setSortTable('TDLS')" :class="setSortLogo('TDLS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TABA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(3))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["BETRPT"]["ARB"] }}
                                        <i @click="setSortTable('TABA')" :class="setSortLogo('TABA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TAA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(4))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["BETRPT"]["AFF"] }}
                                        <i @click="setSortTable('TAA')" :class="setSortLogo('TAA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TTA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['EBD']['TNMTA']}}
                                        <i @click="setSortTable('TTA')" :class="setSortLogo('TTA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TTAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['EBD']['TNMTH']}}
                                        <i @click="setSortTable('TTAH')" :class="setSortLogo('TTAH')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TPA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['EBD']['PDA']}}
                                        <i @click="setSortTable('TPA')" :class="setSortLogo('TPA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TPAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['EBD']['PDH']}}
                                        <i @click="setSortTable('TPAH')" :class="setSortLogo('TPAH')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TFSA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(7))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['FS']}}
                                        <i @click="setSortTable('TFSA')" :class="setSortLogo('TFSA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GTA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['TE']}}
                                        <i @click="setSortTable('GTA')" :class="setSortLogo('GTA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GTHA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['TEA']}}
                                        <i @click="setSortTable('GTHA')" :class="setSortLogo('GTHA')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="26" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                        <tr v-if=" arr_ExpenseBreakGroupByList.length == 0"><td colspan="100%">{{this.getLanguage['GL']['NR']}}</td></tr>
                        <tr v-for="(data,index) in arr_ExpenseBreakGroupByList" class="reportTotal">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    <a href="#" @click="ShowDetails(data.ISOC)">{{getLanguage['WLRPT']['VA']}}</a>
                                </template>
                                <template v-else-if="header == 'MAG'">
                                </template>
                                <template v-else-if="header == 'AGT'">
                                </template>
                                <template v-else-if="header == 'CI'">
                                    {{ renderCurrency(data.ISOC) }}
                                </template>
                                <template v-else-if="header == 'ACTM'">
                                    {{ data.AM }}
                                </template>
                                <template v-else-if="header == 'TBA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(1))" class="tableCtnRight">
                                    {{ formatNumber(data.TBOC * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TDLS' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(2))" class="tableCtnRight">
                                    {{ formatNumber(data.TDLSA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TABA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(3))" class="tableCtnRight">
                                    {{ formatNumber(data.TABA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TAA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(4))" class="tableCtnRight">
                                    {{ formatNumber(data.TAA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TTA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))" class="tableCtnRight">
                                    {{ formatNumber(data.TTA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TTAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))" class="tableCtnRight">
                                    {{ formatNumber(data.TTAH * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TPA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))" class="tableCtnRight">
                                    {{ formatNumber(data.TPA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TPAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))" class="tableCtnRight">
                                    {{ formatNumber(data.TPAH * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TFSA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(7))" class="tableCtnRight">
                                    {{ formatNumber(data.TFSA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'GTA'" class="tableCtnRight">
                                    {{ formatNumber(data.TEA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'GTHA'" class="tableCtnRight">
                                    {{ formatNumber(data.THEA * -1, 2, data.ISOC, false) }}
                                </template>
                            </td>
                        </tr>
                        <draggable v-model="reportHeaders" tag="tr">
                            <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="renderStyle(header)">
                                <template v-if="header == 'NO'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["GL"]["NO"] }}
                                </template>
                                <template v-else-if="header == 'MAG'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage["WLRPT"]["MAG"]}}
                                    <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage["GL"]["AGT"]}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'CI'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["MEM"]["CI"] }}
                                    <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'ACTM'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["MEM"]["ACTM"] }}
                                    <i @click="setSortTable('AM')" :class="setSortLogo('AM')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TBA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(1))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["BETRPT"]["BNS"] }}
                                    <i @click="setSortTable('TBA')" :class="setSortLogo('TBA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TDLS' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(2))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["MEM"]["REWARD"] }}
                                    <i @click="setSortTable('TDLS')" :class="setSortLogo('TDLS')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TABA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(3))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["BETRPT"]["ARB"] }}
                                    <i @click="setSortTable('TABA')" :class="setSortLogo('TABA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TAA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(4))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{ getLanguage["BETRPT"]["AFF"] }}
                                    <i @click="setSortTable('TAA')" :class="setSortLogo('TAA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TTA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['EBD']['TNMTA']}}
                                    <i @click="setSortTable('TTA')" :class="setSortLogo('TTA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TTAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['EBD']['TNMTH']}}
                                    <i @click="setSortTable('TTAH')" :class="setSortLogo('TTAH')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TPA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['EBD']['PDA']}}
                                    <i @click="setSortTable('TPA')" :class="setSortLogo('TPA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TPAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['EBD']['PDH']}}
                                    <i @click="setSortTable('TPAH')" :class="setSortLogo('TPAH')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TFSA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(7))">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MEM']['FS']}}
                                    <i @click="setSortTable('TFSA')" :class="setSortLogo('TFSA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'GTA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLRPT']['TE']}}
                                    <i @click="setSortTable('GTA')" :class="setSortLogo('GTA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'GTHA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLRPT']['TEA']}}
                                    <i @click="setSortTable('GTHA')" :class="setSortLogo('GTHA')" class="sortlogo"></i>
                                </template>
                            </th>
                        </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_ExpenseBreakList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_ExpenseBreakList" v-if="bool_showDetails && str_showDetails == data.ISOC">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ index + 1 }}
                                </template>
                                <template v-else-if="header == 'MAG'">
                                    <span class="grid-line">{{ data.MAGN }}</span>
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <span class="grid-line">{{ data.AGN }} ({{ data.GPC }})</span>
                                    <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                                </template>
                                <template v-else-if="header == 'CI'">
                                    {{ renderCurrency(data.ISOC) }}
                                </template>
                                <template v-else-if="header == 'ACTM'">
                                    {{ data.AM }}
                                </template>
                                <template v-else-if="header == 'TBA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(1))" class="tableCtnRight">
                                    {{ formatNumber(data.TBOC * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TDLS' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(2))" class="tableCtnRight">
                                    {{ formatNumber(data.TDLSA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TABA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(3))" class="tableCtnRight">
                                    {{ formatNumber(data.TABA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TAA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(4))" class="tableCtnRight">
                                    {{ formatNumber(data.TAA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TTA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))" class="tableCtnRight">
                                    {{ formatNumber(data.TTA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TTAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(5))" class="tableCtnRight">
                                    {{ formatNumber(data.TTAH * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TPA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))" class="tableCtnRight">
                                    {{ formatNumber(data.TPA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TPAH' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(6))" class="tableCtnRight">
                                    {{ formatNumber(data.TPAH * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'TFSA' && (arr_FV['ET'].length == 0 || arr_FV['ET'].includes(7))" class="tableCtnRight">
                                    {{ formatNumber(data.TFSA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'GTA'" class="tableCtnRight">
                                    {{ formatNumber(data.TEA * -1, 2, data.ISOC, false) }}
                                </template>
                                <template v-else-if="header == 'GTHA'" class="tableCtnRight">
                                    {{ formatNumber(data.THEA * -1, 2, data.ISOC, false) }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constAccessType, loadingFullScreen, constTournamentType } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                str_tableSortBy: "AGN", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_showSearchBar: true,
                arr_FV: {
                    "PTS": {
                        startDate: this.getMonthStartDate(),
                        endDate: this.getMonthEndDate()
                    },
                    "AGI": [],
                    "AGI_csv": null,
                    "SAGAGI": null,
                    "CI": null,
                    "CCI": null,
                    "ET": []
                },
                arr_ExpenseBreakList: [],
                arr_ExpenseBreakGroupByList: [],
                dd_memberdlsstatus: [],
                dd_agentgroup: [],
                dd_subagentgroup: [],
                ddDefaultSubBrand: [],
                dd_TournamentPayoutOption: [],
                rtSubBrand: 0,
                ddMemberList: [],
                dd_currency: [],
                arry_Psl: [],
                constAccessType: constAccessType,
                hideBrand: false,
                disableSubDD: false,
                //opened: [],
                bool_firstLogin: false,
                dd_currencyfilter: null,
                dd_expense_type: [],
                searchPAgi: 0,
                defaultReportHeaders: ['NO', 'MAG', 'AGT', 'CI', 'ACTM', 'TBA', 'TDLS', 'TABA', 'TAA', 'TTA', 'TTAH', 'TPA', 'TPAH','TFSA','GTA','GTHA'],
                reportHeaders: [],
                needResetHeaders: false,
                str_showDetails: "",
                bool_showDetails: false,
                bool_isDDMV: false,
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.PTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.PTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.PTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.PTS.endDate = "";
                    }
                }
            },
            newSearch() {
                this.$refs.search.focus();
                //this.opened = [];
                this.getExpenseBreakdownList();
            },
            //toggleDisplay(key) {
            //    //this.opened = [];
            //    const index = this.opened.indexOf(key);
            //    if (index > -1) {
            //        this.opened.splice(index, 1)
            //    } else {
            //        this.opened.push(key)
            //    }
            //    this.resizeTableHead();
            //},
            getDropdownList() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
                if (this.arr_FV['CCI'] == null && localStorage.getItem('CCUSD') == "") {
                        localStorage.setItem('CCUSD', this.getUserInfo.CID);
                }
                //this.getDataApi(`/api/dd/cur/0`,
                //    function (d, s) {
                //        if (s) {
                //            for (var i = 0; i < d.dropdownlist.length; i++) {
                //                d.dropdownlist[i].label = that.renderCurrency(d.dropdownlist[i].label);
                //            }
                //            that.dd_currency = d.dropdownlist;
                //            if (that.dd_currency.length > 0) {
                //                if (localStorage.getItem('CCUSD') != "") {
                //                    for (var i = 0; i < that.dd_currency.length; i++) {
                //                        if (that.dd_currency[i].id == localStorage.getItem('CCUSD')) {
                //                            that.arr_FV['CCI'] = that.dd_currency[i].id;
                //                            break;
                //                        }
                //                    }
                //                }
                //            }
                //        }
                //    });
            },
            renderCurrency(ISOC) {
                return this.getLanguage['DB'][ISOC];
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV["AGI_csv"]) {
                    parentAGI = this.arr_FV["AGI_csv"];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }                
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getExpenseBreakdownList();
                    });
            },
            AgentGroupChangefs(value) {
                this.disableSubDD = false;
                this.arr_FV["AGI_csv"] = null;
                this.arr_FV["SAGAGI"] = null;
                if (value != undefined) {
                    if (value != "") {
                        var temp = "";
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.arr_FV["AGI_csv"] = temp;
                        this.searchPAgi = this.arr_FV["AGI_csv"];
                        this.arr_FV["SAGAGI"] = null;
                        if (value.length > 1) {
                            this.disableSubDD = true;
                        }
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI_csv'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currencyfilter = null;
                this.getCurrencyList();
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.arr_FV["SAGAGI"] = agi;
                    }
                }
                else {
                    this.arr_FV['SAGAGI'] = null;
                }
            },
            getExpenseBreakdownList() {
                this.bool_fullLoading = true;                
                var that = this;
                var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (this.arr_FV.PTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.PTS.startDate);
                        path += "&f.STS_from=" + cts_from;
                    }
                    if (this.arr_FV.PTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.PTS.endDate);
                        path += "&f.STS_to=" + cts_to;
                    }
                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.SAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["ET"]) {
                        path += "&f.ET=" + (this.arr_FV["ET"] == null ? "" : this.arr_FV["ET"].join(','))
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                    if (this.arr_FV["CI"] != null) {
                        path += "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);
                    }
                    if (this.arr_FV["CCI"] && this.bool_firstLogin == true) {
                        path += "&f.CCI=" + this.arr_FV["CCI"];
                    }
                    else if (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) {
                        path += "&f.CCI=" + localStorage.getItem('CCUSD');
                        this.bool_firstLogin = true;
                    }
                }

                this.postDataApi(`/api/reports/expbd`, path,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {

                            if (d.R2 == null) {
                                that.arr_ExpenseBreakGroupByList = [];
                            } else {
                                that.arr_ExpenseBreakGroupByList = d.R2;
                            }
                            if (d.R1 == null) {
                                that.arr_ExpenseBreakList = [];
                            } else {
                                that.arr_ExpenseBreakList = d.R1;
                            }
                            that.resizeTableHead();
                        }
                    });
            },
            setTournamentSummaryList(data) {
                this.arry_Psl = [];
                this.decimal_gt = 0;
                if (data != null) {
                    this.arry_Psl = data;
                    if (this.arry_Psl.length != 0) {
                        for (var i = 0; i < this.arry_Psl.length; i++) {
                            this.decimal_gt += this.arry_Psl[i].GT;
                        }
                    }
                }
            },
            renderTournamentType(type) {
                for (var i = 0; i < constTournamentType.length; i++) {
                    if (constTournamentType[i].id == type)
                        return constTournamentType[i].label;
                }
                return "-";
            },
            clearDateRangeFilter() {
                this.arr_FV.PTS = {
                    startDate: this.getTodayDate(),
                    endDate: this.getMonthEndDate()
                };
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {
                var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);
                if (this.arr_FV) {
                    if (this.arr_FV.PTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.PTS.startDate);
                        path += "&f.STS_from=" + cts_from;
                    }
                    if (this.arr_FV.PTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.PTS.endDate);
                        path += "&f.STS_to=" + cts_to;
                    }
                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.SAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["ET"]) {
                        path += "&f.ET=" + (this.arr_FV["ET"] == null ? "" : this.arr_FV["ET"].join(','))
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                    if (this.arr_FV["CI"] != null) {
                        path += "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);
                    }
                    if (this.arr_FV["CCI"] && this.bool_firstLogin == true) {
                        path += "&f.CCI=" + this.arr_FV["CCI"];
                    }
                    else if (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) {
                        path += "&f.CCI=" + localStorage.getItem('CCUSD');
                        this.bool_firstLogin = true;
                    }
                }
                window.open('/api/reports/expbdexcel?' + path, '_blank');

            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }

            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(3) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            updateCC() {
                if (this.arr_FV["CCI"] == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.arr_FV["CCI"]);
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                //this.getDataApi(`/api/dd/currency/${agi}`,
                //    function (d, s) {
                //        if (s) {
                //            that.dd_currencyfilter = d.dropdownlist;
                //        }
                //    });
                var obj_Post = {
                    SelectedBrands1: agi
                };

                this.postDataApi(`/api/dd/curbyagilist/1`, obj_Post,
                    function (d, s) {
                        if (s) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCurrency(d.dropdownlist[i].label);
                            }
                            that.dd_currencyfilter = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCurrency(d.dropdownlist[i].label);
                            }
                            that.dd_currency = d.dropdownlist;
                            if (that.dd_currency.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.dd_currency.length; i++) {
                                        if (that.dd_currency[i].id == localStorage.getItem('CCUSD')) {
                                            that.arr_FV['CCI'] = that.dd_currency[i].id;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    });
            },
            setSortTable(SV) {                
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getExpenseBreakdownList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('GPC')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            renderClassName(header, data) {
                if (this.arr_FV.ET.length > 0 && (
                    (header == 'TBA' && !this.arr_FV.ET.includes(1))
                    || (header == 'TDLS' && !this.arr_FV.ET.includes(2))
                    || (header == 'TABA' && !this.arr_FV.ET.includes(3))
                    || (header == 'TAA' && !this.arr_FV.ET.includes(4))
                    || (header == 'TTA' && !this.arr_FV.ET.includes(5))
                    || (header == 'TTAH' && !this.arr_FV.ET.includes(5))
                    || (header == 'TPA' && !this.arr_FV.ET.includes(6))
                    || (header == 'TPAH' && !this.arr_FV.ET.includes(6))
                    || (header == 'TFSA' && !this.arr_FV.ET.includes(7))
                ))
                    return 'hide-header';
                else if ((header == 'TBA' && data && (data.TBOC * -1 >= 0)) || (header == 'TDLS' && data && (data.TDLSA * -1 >= 0)) || (header == 'TABA' && data && (data.TABA * -1 >= 0)) || (header == 'TAA' && data && (data.TAA * -1 >= 0)) || (header == 'TTA' && data && (data.TTA * -1 >= 0)) || (header == 'TTAH' && data && (data.TTAH * -1 >= 0)) || (header == 'TPA' && data && (data.TPA * -1 >= 0)) || (header == 'TPAH' && data && (data.TPAH * -1 >= 0)) || (header == 'TFSA' && data && (data.TFSA * -1 >= 0)) || (header == 'GTA' && data && (data.TEA * -1 >= 0)) || (header == 'GTHA' && data && (data.THEA * -1 >= 0)) ) {
                    return "tableCtnRight positive-number";
                } else if ((header == 'TBA' && data && (data.TBOC * -1 < 0)) || (header == 'TDLS' && data && (data.TDLSA * -1 < 0)) || (header == 'TABA' && data && (data.TABA * -1 < 0)) || (header == 'TAA' && data && (data.TAA * -1 < 0)) || (header == 'TTA' && data && (data.TTA * -1 < 0)) || (header == 'TTAH' && data && (data.TTAH * -1 < 0)) || (header == 'TPA' && data && (data.TPA * -1 < 0)) || (header == 'TPAH' && data && (data.TPAH * -1 < 0)) || (header == 'TFSA' && data && (data.TFSA * -1 <0)) || (header == 'GTA' && data && (data.TEA * -1 <0)) || (header == 'GTHA' && data && (data.THEA * -1 <0))) {
                    return "tableCtnRight negative-number";
                } else if (header == 'ACTM' || header == 'TBA' || header == 'TDLS' || header == 'TABA' || header == 'TAA' || header == 'TTA' || header == 'TTAH' || header == 'TPA' || header == 'TPAH' || header == 'TFSA' || header == 'GTA' || header == 'GTHA') {
                    return "tableCtnRight";
                }
            },
            renderStyle(header, data) {
                if (header == 'TBA' || header == 'TDLS' || header == 'TABA' || header == 'TAA' || header == 'TTA' || header == 'TTAH' || header == 'TPA' || header == 'TPAH' || header == 'TFSA') {
                        return "background: lightcoral !important; color: whitesmoke !important";
                } else if (header == 'GTA' || header == 'GTHA') {
                    return "background: rgb(86, 44, 135) !important";
                }
            },
            ShowDetails(currency) {
                if (this.str_showDetails != currency) {
                    this.str_showDetails = currency;
                    this.bool_showDetails = true;
                }
                else {
                    this.bool_showDetails = !this.bool_showDetails;
                }
                this.resizeTableHead();
            },
            getExpenseType() {
                this.dd_expense_type = [
                    { id: 1, label: this.getLanguage['DB']['BONUS'] },
                    { id: 2, label: this.getLanguage['MEM']['REWARD'] },
                    { id: 3, label: this.getLanguage['DB']['DBAR'] },
                    { id: 4, label: this.getLanguage['DB']['RFF'] },
                    { id: 5, label: this.getLanguage['DB']['DBTNMT'] },
                    { id: 6, label: this.getLanguage['DB']['PZD'] },
                    { id: 7, label: this.getLanguage['DB']['FS'] }
                ];
            }
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.EBD';
            if (this.checkModuleIndex('EBD', 'R', constAccessType.view, '', -1) == '7.2.12') {
                this.$parent.showSubSubMenu = 'RS2';
            } else if (this.checkModuleIndex('EBD', 'R', constAccessType.view, '', -1) == '7.5.7') {
                this.$parent.showSubSubMenu = 'RS5';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;                   

            if (this.$route.query.agi) {
                this.arr_FV.AGI.push(this.$route.query.agi);
                this.AgentGroupChangefs(this.arr_FV.AGI)
            }
            if (this.$route.query.ci) {
                this.arr_FV.CI = this.$route.query.ci;
            }
            if (this.$route.query.df) {
                this.arr_FV.PTS.startDate = this.$route.query.df;
            }
            if (this.$route.query.dt) {
                this.arr_FV.PTS.endDate = this.$route.query.dt;
            }
            if (this.$route.query.sagi && this.$route.query.sagn) {
                this.arr_FV.SAGAGI = this.$route.query.sagi;
                this.ddDefaultSubBrand = [{ id: this.arr_FV.SAGAGI, label: this.$route.query.sagn}];
            }
            this.getDropdownList();
            this.getCurrencyList();
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);
            this.getExpenseType();
            // Filter Type of Expenses when redirecting from Dashboard
            if (this.$route.query.expensesType == "BNS") {
                this.arr_FV.ET.push(1);
            }
            else if (this.$route.query.expensesType == "DLS") {
                this.arr_FV.ET.push(2);
            }
            else if (this.$route.query.expensesType == "AR") {
                this.arr_FV.ET.push(3);
            }
            else if (this.$route.query.expensesType == "AFF") {
                this.arr_FV.ET.push(4);
            }
            else if (this.$route.query.expensesType == "TNMT") {
                this.arr_FV.ET.push(5);
            }
            else if (this.$route.query.expensesType == "MSA") {
                this.arr_FV.ET.push(6);
            }
            if (this.$route.path != this.$route.fullPath) {
                this.getExpenseBreakdownList();
            }
        },
        watch: {
            getLanguage() {
                this.getExpenseBreakdownList();
                this.getCurrencyList();
                this.getExpenseType();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/ExpenseBreakdown`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                //if (that.hideBrand) {
                                //    that.removeDefaultColumn('GPC')
                                //    that.removeColumn('GPC')
                                //}
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/ExpenseBreakdown/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>
<style>
    .hide-header{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/ExpenseBreakdown.vue